'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconDefault = function IconDefault(props) {
	return _react2.default.createElement(
		'svg',
		props,
		_react2.default.createElement(
			'g',
			{
				fill: '#FFF',
				fillRule: 'evenodd'
			},
			_react2.default.createElement('path', {
				d: 'M14.133 6.92a.868.868 0 0 1-.747-.424C13.307 6.365 11.374 3.23 7.5 3.23c-3.905 0-5.867 3.232-5.886 3.265A.869.869 0 0 1 .121 5.61c.1-.168 2.497-4.115 7.38-4.115 4.881 0 7.278 3.947 7.377 4.115a.865.865 0 0 1-.745 1.31'
			}),
			_react2.default.createElement('path', {
				d: 'M7.5 3.841c-1.22 0-2.212.992-2.212 2.212A2.212 2.212 0 1 0 7.5 3.841m0 6.16a3.952 3.952 0 0 1-3.947-3.948A3.952 3.952 0 0 1 7.5 2.106a3.952 3.952 0 0 1 3.947 3.947A3.952 3.952 0 0 1 7.5 10'
			})
		)
	);
};

IconDefault.defaultProps = {
	width: '15',
	height: '11',
	viewBox: '0 0 15 11',
	xmlns: 'http://www.w3.org/2000/svg'
};

var Eye = function (_React$Component) {
	_inherits(Eye, _React$Component);

	function Eye() {
		_classCallCheck(this, Eye);

		return _possibleConstructorReturn(this, (Eye.__proto__ || Object.getPrototypeOf(Eye)).apply(this, arguments));
	}

	_createClass(Eye, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(IconDefault, null);
		}
	}]);

	return Eye;
}(_react2.default.Component);

exports.default = Eye;